var _rect, _g, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D1FADF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_6959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23L22.1667 24.6667L25.9167 20.9167M19.1115 16.1822C19.7814 16.1288 20.4173 15.8654 20.9287 15.4295C22.1223 14.4124 23.8778 14.4124 25.0713 15.4295C25.5828 15.8654 26.2187 16.1288 26.8885 16.1822C28.4517 16.307 29.693 17.5483 29.8178 19.1115C29.8712 19.7813 30.1346 20.4173 30.5705 20.9287C31.5876 22.1223 31.5876 23.8777 30.5705 25.0713C30.1346 25.5827 29.8712 26.2187 29.8178 26.8885C29.693 28.4517 28.4517 29.693 26.8885 29.8177C26.2187 29.8712 25.5828 30.1346 25.0713 30.5705C23.8778 31.5876 22.1223 31.5876 20.9287 30.5705C20.4173 30.1346 19.7814 29.8712 19.1115 29.8177C17.5483 29.693 16.307 28.4517 16.1823 26.8885C16.1288 26.2187 15.8654 25.5827 15.4295 25.0713C14.4124 23.8777 14.4124 22.1223 15.4295 20.9287C15.8654 20.4173 16.1288 19.7813 16.1823 19.1115C16.307 17.5483 17.5483 16.307 19.1115 16.1822Z",
    stroke: "#039855",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#ECFDF3",
    strokeWidth: 6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_6959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOk);
export default __webpack_public_path__ + "static/media/notification_ok.9a8dd1c94edbcc26eed187e648a0b564.svg";
export { ForwardRef as ReactComponent };